import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { CarouselSend } from '../_model/carousel';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CarouselService {

constructor(private http: HttpClient) { }

baseUrl = "https://"+environment.apiUrl+"/api/carousel/";

list() {
  return this.http.post(this.baseUrl+"list",null)
    .pipe(
      map((data: any) => {
        return data.result;
      })
    )
}

send(model: CarouselSend) {
  return this.http.post(this.baseUrl+"input", model);
}
media(name: string) {
  return this.http.post(this.baseUrl+"media/"+name, null)
    .pipe(
      map((data: any) => {
        return data.result;
      })
    );
}

}
